import { create } from "zustand";
import { getPublicConfig, type PublicConfig } from "../services/api";

interface InstanceSettingsStore {
  settings: PublicConfig | null;
  loading: boolean;
  error: string | null;
  loadSettings: () => Promise<void>;
}

export const useInstanceSettingsStore = create<InstanceSettingsStore>(
  (set) => ({
    settings: null,
    loading: false,
    error: null,

    loadSettings: async () => {
      set({ loading: true, error: null });
      try {
        const settings = await getPublicConfig();
        set({ settings, loading: false });
      } catch (err) {
        set({
          error: err instanceof Error ? err.message : "Failed to load settings",
          loading: false,
        });
      }
    },
  }),
);
